import React, {Component} from 'react';


import youtubePreview from './images/for-the-sales-FA.gif';


class Entrepreneurs extends Component {


  render(){
    return(
      <section>
        <div className="bg-lightGrey py-5" style={{background: '#AAC5CD'}}>
          <div className="container marketingSection">
            <div className="row">
              <div className="col-md-12 text-center">
                <img src={youtubePreview} className="img-fluid" alt="" style={{maxWidth:"500px", cursor: "pointer"}} />
              </div>

            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Entrepreneurs


// WEBPACK FOOTER //
// ./src/sections/signupPage/forTheSales/index.js